import { SAVE_SESSION } from '../actions/session';
import Session from '../Session';

const initialState = {
  session: new Session(),
  isRestored: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_SESSION:
      return {
        session: action.session,
        isRestored: true,
      };

    default:
  }

  return state;
};
